import gql from 'graphql-tag';

export default gql`
query adminUserName($filters: UserFilters, $sortBy: UserSort, $count: Int!, $page: Int) {
    listUsers(filters: $filters, sortBy: $sortBy, first: $count, page: $page) {
        data {
            name
        }
    }
}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/adminUserName.ts